// extracted by mini-css-extract-plugin
export default {"headerText":"PermissionStatusBulkApply__headerText___ScDeg"};